import axios from 'axios'
// import swal from 'sweetalert'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

let defaultState = {
  proposals: [],
  proposalProjects: [],
  proposalCount: 0,
  currentProposalsPage: 1,
  proposalResultsPerPage: 0,
  inPrepCount: 0,
  lostCount: 0,
  waitingCount: 0,
  wonCount: 0,
  fetchingProposals: false,
  fetchingProposalMetadata: false,
  fetchingProposalProjects: false,
  proposalMetadata: [],
  // currentProposal: null,
  // projectsToAddToCurrentProposal: []
}

export default function manageProposals(state = defaultState, action) {
  switch (action.type) {
    case "FETCHING_PROPOSALS":
      return { ...state, fetchingProposals: true }
    case "FETCHING_PROPOSAL_METADATA":
      return { ...state, fetchingProposalMetadata: true }
    case "FETCHING_PROPOSAL_PROJECTS":
      return { ...state, fetchingProposalProjects: true }
    case "SET_PROPOSALS":
      if (action.payload && action.payload.results) {
        return {
          ...state,
          fetchingProposals: false,
          proposals: action.payload.results,
          proposalResultsPerPage: action.payload.results_per_page,
          proposalCount: action.payload.count,
          inPrepCount: action.payload.in_prep_count,
          lostCount: action.payload.lost_count,
          waitingCount: action.payload.waiting_count,
          wonCount: action.payload.won_count,
        }
      } else {
        return {
          ...state,
          fetchingProposals: false,
          proposals: [],
          proposalCount: 0,
          proposalResultsPerPage: 0,
          inPrepCount: 0,
          lostCount: 0,
          waitingCount: 0,
          wonCount: 0,
        }
      }
    // case "SET_CURRENT_PROPOSAL":
    //   let projectsToAddToCurrentProposal = []
    //   const currentProposal = action.payload
    //   if (currentProposal) {
    //     projectsToAddToCurrentProposal = currentProposal.projects
    //   }
    //   return {
    //     ...state, fetchingProposals: false,
    //     currentProposal,
    //     projectsToAddToCurrentProposal
    //   }
    case "CHANGE_PROPOSALS_PAGINATION_PAGE":
      return { ...state, currentProposalsPage: action.payload }
    // case "ADD_PROJECTS_TO_CURRENT_PROPOSAL":
    //   return { ...state, projectsToAddToCurrentProposal: action.payload }
    // case "EDIT_PROPOSAL":
    //   return {
    //     ...state,
    //     currentProposal: {
    //       ...state.currentProposal,
    //       [action.payload.key]: action.payload.value
    //     },
    //     projectsToAddToCurrentProposal: [],
    //   }
    case "SET_PROPOSAL_METADATA":
      return {
        ...state,
        fetchingProposalMetadata: false,
        proposalMetadata: action.payload
      }
    case "ADD_PROPOSAL_METADATA":
      return {
        ...state,
        proposalMetadata: [...state.proposalMetadata, action.payload]
      }
    case "EDIT_PROPOSAL_METADATA":
      const indexOfMetadata = state.proposalMetadata.findIndex(meta => meta.id === action.payload.id)

      return {...state, proposalMetadata: [...state.proposalMetadata.slice(0, indexOfMetadata), action.payload, ...state.proposalMetadata.slice(indexOfMetadata + 1)]}
    case "DELETE_PROPOSAL_METADATA":
      return {
        ...state,
        proposalMetadata: state.proposalMetadata.filter(meta => meta.id !== action.payload)
      }
    case "ADD_PROPOSAL_METADATA_VALUE":
      const foundMetadataIndex = state.proposalMetadata.findIndex(meta => {
        return meta.url === action.payload.proposal_metadata
      })
      const updatedMetadata = {
        ...state.proposalMetadata[foundMetadataIndex],
        proposal_metadata_values: [
          ...state.proposalMetadata[foundMetadataIndex].proposal_metadata_values, action.payload
        ]
      }
      const updatedMetadataList = [
        ...state.proposalMetadata.slice(0, foundMetadataIndex),
        updatedMetadata,
        ...state.proposalMetadata.slice(foundMetadataIndex + 1),

      ]
      return { ...state, proposalMetadata: updatedMetadataList }
    case "EDIT_PROPOSAL_METADATA_VALUE":
      const metadataIndex = state.proposalMetadata.findIndex(meta => meta.url === action.payload.proposal_metadata)

      let updatedMeta = state.proposalMetadata[metadataIndex]

      const valueIndex = updatedMeta.proposal_metadata_values.findIndex(value => value.id === action.payload.id)

      updatedMeta = {...updatedMeta, proposal_metadata_values: [...updatedMeta.proposal_metadata_values.slice(0, valueIndex), action.payload, ...updatedMeta.proposal_metadata_values.slice(valueIndex + 1)]}

      return {
        ...state,
        proposalMetadata: [
          ...state.proposalMetadata.slice(0, metadataIndex),
          updatedMeta,
          ...state.proposalMetadata.slice(metadataIndex + 1),
        ]
      }
    case "DELETE_PROPOSAL_METADATA_VALUES":
      const proposalMetadataIndex = state.proposalMetadata.findIndex(meta => meta.url === action.payload.proposal_metadata)

      let updatedProposalMetadata = state.proposalMetadata[proposalMetadataIndex]

      const filteredProposalMetadataValues = updatedProposalMetadata.proposal_metadata_values.filter(value => value.id !== action.payload.id)

      updatedProposalMetadata = {
        ...updatedProposalMetadata,
        proposal_metadata_values: filteredProposalMetadataValues,
      }

      return {
        ...state,
        proposalMetadata: [
          ...state.proposalMetadata.slice(0, proposalMetadataIndex),
          updatedProposalMetadata,
          ...state.proposalMetadata.slice(proposalMetadataIndex + 1),
        ]
      }
    case "SET_PROPOSAL_PROJECTS":
      return {
        ...state,
        fetchingProposalProjects: false,
        proposalProjects: action.payload
      }
    default:
      return state
  }
}

const fetchingProposals = () => {
  return { type: "FETCHING_PROPOSALS" }
}

const fetchingProposalMetadata = () => {
  return { type: "FETCHING_PROPOSAL_METADATA" }
}

const fetchingProposalProjects = () => {
  return { type: "FETCHING_PROPOSAL_PROJECTS" }
}

const setProposals = (proposals) => {
  return { type: "SET_PROPOSALS", payload: proposals }
}

export const changeProposalsPage = (page) => {
  return { type: "CHANGE_PROPOSALS_PAGINATION_PAGE", payload: page }
}

// const setCurrentProposal = (proposal) => {
//   return { type: "SET_CURRENT_PROPOSAL", payload: proposal}
// }

// const editedProposal = (payload) => {
//   return {type: "EDIT_PROPOSAL", payload }
// }

const setProposalMetadata = (metadata) => {
  return { type: "SET_PROPOSAL_METADATA", payload: metadata }
}

export const addProposalMetadata = (metadata) => {
  return { type: "ADD_PROPOSAL_METADATA", payload: metadata }
}

export const editProposalMetadata = (metadata) => {
  return { type: "EDIT_PROPOSAL_METADATA", payload: metadata }
}

export const deleteProposalMetadata = (metadataId) => {
  return { type: "DELETE_PROPOSAL_METADATA", payload: metadataId }
}

export const addProposalMetadataValue = (metadataValue) => {
  return { type: "ADD_PROPOSAL_METADATA_VALUE", payload: metadataValue }
}

export const editProposalMetadataValue = (metadataValue) => {
  return { type: "EDIT_PROPOSAL_METADATA_VALUE", payload: metadataValue }
}

export const deleteProposalMetadataValue = (metadataValue) => {
  return { type: "DELETE_PROPOSAL_METADATA_VALUES", payload: metadataValue }
}

const setProposalProjects = (projects) => {
  return { type: "SET_PROPOSAL_PROJECTS", payload: projects }
}

// export const addProjectsToCurrentProposal = (projects) => {
//   return {type: "ADD_PROJECTS_TO_CURRENT_PROPOSAL", payload: projects}
// }

export const getProposalsWithFilters = (page = 1, proposalFilters) => {
  return (dispatch) => {
    const { filters, sort_by } = createFilters(proposalFilters)
    dispatch(getProposals(page, filters, sort_by, proposalFilters.myProposalsFilter))
  }
}

export const createFilters = (props) => {
  let filters, sort_by, title, status, client, proposal_lead, client_manager, analysts, proposal_metadata_values, category

  if (props.proposalLeadFilters.length) {
    proposal_lead = props.proposalLeadFilters.map(lead => lead.id)
  }

  if (props.proposalClientManagerFilters.length) {
    client_manager = props.proposalClientManagerFilters.map(manager => manager.id)
  }

  if (props.proposalAnalystFilters.length) {
    analysts = props.proposalAnalystFilters.map(analyst => analyst.id)
  }

  if (props.proposalClientFilters.length) {
    client = props.proposalClientFilters.map(client => client.id)
  }

  if (props.proposalMetadataValuesFilters.length) {
    proposal_metadata_values = props.proposalMetadataValuesFilters.map(value => value.id)
  }

  if (props.proposalStatusFilters.length) {
    status = props.proposalStatusFilters
  }

  if (props.proposalNameFilter) {
    title = props.proposalNameFilter
  }

  if (props.proposalCategoryFilters.length) {
    category = props.proposalCategoryFilters
  }

  if (title || status || client || proposal_lead || client_manager || analysts || proposal_metadata_values || category) {
    filters = {
        title,
        status,
        client,
        proposal_lead,
        client_manager,
        analysts,
        proposal_metadata_values,
        category,
      }
  }

  if (props.proposalSortType) {
    sort_by = props.proposalSortType
  }

  return { filters, sort_by }
}

export const getProposals = (page = 1, filters = null, sort_by = null, my_proposals = false) => {
  return (dispatch) => {
    dispatch(fetchingProposals())
    axios(`${getServerURL()}proposals/?page=${page}` ,
      { headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
      params: {
        list_view: true,
        filters,
        sort_by,
        my_proposals,
      }
    })
    .then(response => {
      dispatch(setProposals(response.data))
    })
    .catch(error => {
      const message = "There was an error fetching the proposals"
      handleErrorFetchingData(error, message)
      dispatch(setProposals(null))
    })
  }
}

export const getProposalMetadata = (dispatch) => {
  return (dispatch) => {
    dispatch(fetchingProposalMetadata())
    axios(`${getServerURL()}proposal-metadata/` ,
      { headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
    })
    .then(response => {
      dispatch(setProposalMetadata(response.data))
    })
    .catch(error => {
      handleErrorFetchingData(error)
    })
  }
}

export const getProposalProjects = (dispatch) => {
  return (dispatch) => {
    dispatch(fetchingProposalProjects())
    axios(`${getServerURL()}proposal-projects/` ,

      { headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
    })
    .then(response => {
      dispatch(setProposalProjects(response.data))
    })
    .catch(error => {
      handleErrorFetchingData(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/routes/proposals/reducers/manageProposals.js